import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils/apiInterceptor';
import { API_BASE_URL } from '../../utils/paths';

export const fetchForecastData = createAsyncThunk(
  'forecast/fetchSpotForecast',
  async (spotId, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/spots/${spotId}/forecast`, {
        method: 'GET',
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

export const fetchForecastDataByLocation = createAsyncThunk(
  'forecast/fetchForecastByLocation',
  async (location, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/spots/forecast?lat=${location.lat}&lon=${location.lon}`, {
        method: 'GET',
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

// spots/all/forecast
export const fetchAllSpotsForecast = createAsyncThunk(
  'forecast/fetchAllSpotsForecast',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/spots/all/forecast`, {
        method: 'GET',
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

const forecastSlice = createSlice({
    name: 'forecast',
    initialState: {
        spotsForecastData: [],
        forecastData: null,
        isLoading: false,
        errors: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchForecastData.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchForecastData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.forecastData = action.payload;
            })
            .addCase(fetchForecastData.rejected, (state, action) => {
                state.isLoading = false;
                state.errors = action.payload || { message: 'Failed to fetch forecast' };
            })
            .addCase(fetchForecastDataByLocation.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchForecastDataByLocation.fulfilled, (state, action) => {
                state.isLoading = false;
                state.forecastData = action.payload;
                state.errors = null;
            })
            .addCase(fetchForecastDataByLocation.rejected, (state, action) => {
                state.isLoading = false;
                state.errors = action.payload || { message: 'Failed to fetch forecast' };
            })
            .addCase(fetchAllSpotsForecast.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchAllSpotsForecast.fulfilled, (state, action) => {
                state.isLoading = false;
                state.spotsForecastData = action.payload;
            })
            .addCase(fetchAllSpotsForecast.rejected, (state, action) => {
                state.isLoading = false;
                state.errors = action.payload || { message: 'Failed to fetch all spots forecast' };
            });
    }
});

export default forecastSlice.reducer